import request from '@/utils/request';

export function submitFeedback(data) {
  return request({
    url: '/front/feedback',
    method: 'post',
    data
  });
}
